<template>
  <div>
    <v-alert class="rounded-lg mb-0" :color="notification.backgroundColor">
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-icon :color="notification.iconColor">{{
            notification.icon
          }}</v-icon>
        </v-col>

        <v-col>
          <v-row no-gutters align="center">
            <v-col class="text-start">
              <span
                class="caption font-weight-bold textLight--text"
                :class="limitLines ? 'text-ellipse-1' : ''"
              >
                {{ getLocalisedValue(notification.title) }}
              </span>
            </v-col>
          </v-row>

          <v-row v-if="notification.message" no-gutters class="mt-1">
            <v-col class="text-start">
              <span
                class="caption font-weight-regular textLight--text"
                :class="limitLines ? 'text-ellipse-2' : ''"
              >
                {{ getLocalisedValue(notification.message) }}
              </span>
            </v-col>
          </v-row>

          <v-row no-gutters justify="end">
            <v-col cols="auto" class="text-end">
              <span
                class="font-weight-light secondary--text"
                style="font-size: 10px"
              >
                {{
                  this.moment(parseInt(notification.createdAt)).format(
                    "DD MMM YYYY hh:mm a"
                  )
                }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "NotificationAlert",
  props: {
    data: {
      type: Object,
      required: true,
    },
    limitLines: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    notification() {
      const notificationItem = this.data;

      if (
        notificationItem.notificationType === "TRAINING_NEW_ENROLLMENT" ||
        notificationItem.notificationType === "EMPLOYEE_JOINED"
      ) {
        return {
          ...notificationItem,
          icon: "mdi-account-plus-outline",
          iconColor: "#0097A7",
          backgroundColor: "#0097a733",
        };
      } else if (notificationItem.notificationType === "TRAINING_COMPLETED") {
        return {
          ...notificationItem,
          icon: "mdi-check-circle-outline",
          iconColor: "#388E3C",
          backgroundColor: "#388e3c33",
        };
      } else if (notificationItem.notificationType === "TRAINING_QUIZ_FAILED") {
        return {
          ...notificationItem,
          icon: "mdi-alert-octagon-outline",
          iconColor: "#FF5252",
          backgroundColor: "#ff525233",
        };
      } else if (
        notificationItem.notificationType === "TRAINING_APPROVAL_REQUEST"
      ) {
        return {
          ...notificationItem,
          icon: "mdi-clipboard-clock-outline",
          iconColor: "#281166",
          backgroundColor: "#388e3c33",
        };
      } else if (notificationItem.notificationType === "TRAINING_REJECTED") {
        return {
          ...notificationItem,
          icon: "mdi-alert-octagon-outline",
          iconColor: "#FF5252",
          backgroundColor: "#ff525233",
        };
      } else {
        return {
          ...notificationItem,
          icon: "mdi-square-rounded-badge-outline",
          iconColor: "#281166",
          backgroundColor: "#388e3c33",
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
>>> .v-alert__content {
  display: flex;
}
</style>
